import { Component, Inject, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Store } from '@ngrx/store';

import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

import { MessageActions } from 'src/app/common/store/actions/message.actions';
import { selectConversation, selectConversationFromDealerById, selectLoggedInUserDataId } from 'src/app/common/store/state/app.state';
import { Observable } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { AppFunctions } from '../../constants/app-functions';
import { Conversation } from '../../models/conversation.model';
import { Message } from '../../models/message.model';
import { ObjectData } from '../../models/object-data.model';

import { MatInputModule } from '@angular/material/input';


@Component({
    selector: 'app-conversation-dialog',
    templateUrl: './conversation-dialog.component.html',
    styleUrls: ['./conversation-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, MatFormFieldModule, MatInputModule, MatDialogModule, MatIconModule]
})
export class ConversationDialogComponent implements OnInit{

  isNew: boolean = false;
  reply: string = "";

  currentUserId$ : Observable<string>;
  currentUserId: string = "";

  conversation$ : Observable<Conversation | undefined>;
  conversation: Conversation = new Conversation();

  receiverId: string = "";
  
  constructor(
    public dialogRef: MatDialogRef<ConversationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ObjectData,
    private store: Store) {

        this.currentUserId$ = store.select(selectLoggedInUserDataId);

        this.conversation$ = store.select(selectConversation( data.objectSource, data.offerId, data.objectId )); 

        //this.conversation = Object.assign(new Conversation(), data)
    }

    ngOnInit(): void {

      this.currentUserId$.subscribe(
          (id: string) => this.currentUserId = id
      );

      this.conversation$.subscribe(
        (conv: Conversation | undefined) => {
          this.conversation = conv == undefined ? new Conversation() : conv
          this.reply = ""
        }
      );
  
    } 
  
    onNoClick(): void {
      this.dialogRef.close();
    }

    sendMessage(){
        //console.log("reply = "+reply+" car = "+carId+" conv = "+conversationId)
        
        let message = new Message();
        message.senderId = this.currentUserId;
        message.receiverId = this.receiverId;
        message.conversationId = this.conversation.id;
        message.body = this.reply;

        if(this.conversation.id > 0 ){
          message.offerId = this.conversation.offerId
        }
        else{
          message.offerId = this.data.offerId
          message.businessLine = this.data.businessLine
        }

        this.store.dispatch(MessageActions.sendNewMessageSubmit({message: message, objectSource: this.data.objectSource }));
        
      /* 
        if(conversationId == 0){
            let message = new Message();
            //message.receiverId = this.c
            message.body = reply;
            this.store.dispatch(MessageActions.sendNewMessageSubmit({message: message }));
        }
        else {
            this.store.dispatch(MessageActions.replyMessageSubmit({reply: reply, carId: carId, conversationId: conversationId }));
        }

        this.dialogRef.close();  
        */
    }

    dateFormat(dt: string): string{

      return AppFunctions.stringToDatetime(dt);
    }
}
